import { Card, CardTitle } from './ui/card';
import { EMPTY_KPI_VALUE } from '../utils/kpiMetric';

// Классы перечислены целиком: Tailwind не увидит собранное из строки имя. Число колонок следует
// за числом видимых плиток, иначе скрытая в настройках плитка оставляла бы в ряду дыру.
const KPI_STRIP_COLUMNS = {
  1: 'xl:grid-cols-1',
  2: 'xl:grid-cols-2',
  3: 'xl:grid-cols-3',
  4: 'xl:grid-cols-4',
  5: 'xl:grid-cols-5',
  6: 'xl:grid-cols-6'
};

/** Плитки одной карточкой: верхняя полоса и показатели вкладки «Сотрудники» выглядят одинаково. */
export const KpiStrip = ({ count, children }) => (
  <Card className={`grid grid-cols-1 gap-px overflow-hidden bg-border sm:grid-cols-2 ${KPI_STRIP_COLUMNS[count]}`}>
    {children}
  </Card>
);

/**
 * Плитка: подпись и строка «число, рядом дополнение». Высота строк одна во всех плитках, поэтому
 * числа стоят вровень, даже если подпись одной из них в две строки (`twoLineTitle`). На узких
 * колонках (полоса в ряд до 1400 px) значок убран, а число мельче: иначе обрезались бы длинная
 * подпись и большое значение с процентом.
 */
export const KpiTile = ({ panelId, title, hint, icon: Icon, value, twoLineTitle, isLoading = false, children }) => (
  <div
    data-panel-id={panelId}
    className="flex min-w-0 flex-col bg-card px-4 py-3.5 sm:[&:last-child:nth-child(odd)]:col-span-2 xl:[&:last-child:nth-child(odd)]:col-span-1 xl:max-[1399px]:px-3.5"
  >
    <div className={`flex min-w-0 items-center gap-1 ${twoLineTitle ? 'h-9' : 'h-7'}`}>
      <CardTitle
        className={`min-w-0 text-[13px] font-medium leading-tight text-muted-foreground ${twoLineTitle ? 'line-clamp-2' : 'truncate'}`}
        title={title}
      >
        {title}
      </CardTitle>
      {hint}
      <span className="ml-auto flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600 dark:bg-blue-950/40 dark:text-blue-300 xl:max-[1399px]:hidden">
        <Icon className="h-4 w-4" strokeWidth={1.8} />
      </span>
    </div>
    <div className={`mt-1 flex min-w-0 items-baseline gap-2 transition-opacity ${isLoading ? 'opacity-60' : ''}`} aria-busy={isLoading}>
      <div
        data-kpi-value
        className={`min-w-0 truncate text-[28px] font-semibold leading-8 tracking-tight xl:max-[1399px]:text-2xl ${value === EMPTY_KPI_VALUE ? 'text-muted-foreground' : ''}`}
        title={String(value)}
      >
        {value}
      </div>
      {children}
    </div>
  </div>
);
